/* eslint-disable react/jsx-filename-extension */
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledPackageContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
  border-radius: 16px;
  background-color: ${COLOR.white};
  height: calc(100% - 32px);
  .buy-more-btn {
    font-size: 16px;
    font-weight: 700;
    padding: 8px 16px;
    border-radius: 12px;
    text-transform: none;
    background-color: ${COLOR.yellow.default};
    width: ${(props) => (props.isMobile ? '' : '50%')};
    align-self: center;
  }
  .package-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid ${COLOR.label[16]};
    padding-bottom: 16px;
    min-height: 54px;
    .package-header-container {
      display: flex;
      gap: 0 2px;
      flex-wrap: wrap;
      align-items: center;
      .package-name-container {
        display: flex;
        gap: 2px;
        flex-direction: row;
        align-items: center;
        width: 100%;
        .product-type-text {
          color: ${COLOR.darkGray};
          font-size: 20px;
          font-weight: 700;
          line-height: 28px;
          margin-bottom: 2px;
        }
        .package-name-text {
          color: ${COLOR.darkGray};
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
        }
      }
    }
    .auto-renewal-container {
      display: flex;
      justify-content: end;
      width: 100%;
      align-items: center;

      .auto-renewal {
        display: flex;
        width: fit-content;
        padding: 4px 10px;
        border-radius: 16px;
        background-color: ${COLOR.indigo[8]};
        font-size: 12px;
        font-weight: 510;
        line-height: 16px;
        letter-spacing: -0.4px;
        color: ${COLOR.darkBlue};
      }
    }
  }

  .package-retention-text-container {
    display: flex;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    align-self: self-start;
    gap: 4px;
    border-radius: 480px;
    flex-wrap: wrap;
    background: ${COLOR.functionalRed[8]};
    .package-retention-text {
      color: ${COLOR.functionalRed.default};
      text-align: center;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }
    .package-retention-date {
      color: ${COLOR.functionalRed.default};
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
    }
  }
  .credit-per-cycle {
    font-size: 14px;
    font-weight: 400;
    font-style: italic;
    color: ${COLOR.label2[64]};
  }

  .package-wrapper {
    display: flex;
    padding: 12px 16px;
    flex-direction: column;
    align-items: normal;
    gap: 16px;
    border-radius: 12px;
    border: 1px solid ${COLOR.label[16]};
    .title {
      font-size: 16px;
      font-weight: 700;
    }
  }

  .old-plan-package-name {
    color: ${COLOR.darkGray};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.4px;
  }

  @media (max-width: 375px) {
    padding: 16px 10px;
  }
`;

export const StyledExpDate = styled('div')`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  .exp-date-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;

    .label {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: ${COLOR.black.default};
    }
    .expired-container {
      display: flex;
      height: 24px;
      padding: 4px 12px;
      justify-content: center;
      align-items: center;
      border-radius: 480px;
      background: ${COLOR.functionalRed[8]};
      .expired-label {
        color: ${COLOR.functionalRed.default};
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
  .content {
    color: ${COLOR.black.default};
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }
`;

export const StyledCharacterPreservationReminder = styled('div')`
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background-color: ${COLOR.functionalRed[8]};
  .icon-warning {
    color: ${COLOR.functionalRed.default};
    width: 24px;
    height: 24px;
  }
`;
